import script from "./PadelLateralTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./PadelLateralTab.vue?vue&type=script&lang=ts&setup=true"

import "./PadelLateralTab.vue?vue&type=style&index=0&id=0ab5d2ba&lang=scss&scoped=true"
script.__scopeId = "data-v-0ab5d2ba"

export default script